module.exports = __webpack_public_path__ + "images/emoji/leopard.b063948591056e86953b.png";